import * as ACTION from './constants';
import * as apiService from '../../services/apiServices';

// ACTION CREATORS
export const settingsBase = () => ({ type: ACTION.SETTINGS_BASE });
export const isStripeVerifying = () => ({ type: ACTION.STRIPE_VERIFYING });
export const stripeVerified = (verified = false) => ({ type: ACTION.STRIPE_VERIFIED, verified });
export const stripeNotVerified = () => ({ type: ACTION.STRIPE_NOT_VERIFIED });

export const isFetchingUserSettings = () => ({ type: ACTION.GET_USER_DATA });
export const setUserSettings = (payload = null) => ({
  type: ACTION.SET_USER_DATA,
  payload,
});

export const getAccountSettings = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(isFetchingUserSettings());
    apiService
      .getAccountSettings()
      .then((response) => {
        dispatch(setUserSettings(response));
        resolve(response);
      })
      .catch((error) => {
        dispatch(setUserSettings());
        reject(error);
      });
  });
};

export const verifyStripeAuthCode = (state, code) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(isStripeVerifying());
    apiService.verifyStripeAuthCode(state, code)
    .then(response => {
      if (response.stripe_connected) {
        dispatch(stripeVerified(true));
      }
      else {
        dispatch(stripeNotVerified())
      }
      resolve(response);
    })
    .catch(error => {
      dispatch(settingsBase());
      reject(error);
    });
  });
}

export const setStripeVerification = (verified) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(stripeVerified(verified));
    resolve();
  });
}
